import { render, staticRenderFns } from "./TemplateChoose.vue?vue&type=template&id=aebf3a26&"
import script from "./TemplateChoose.vue?vue&type=script&lang=js&"
export * from "./TemplateChoose.vue?vue&type=script&lang=js&"
import style0 from "./TemplateChoose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports